import React from 'react';

import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import { instituteDetailsStyles } from './styles';
import ApiService from '@common/services/ApiService';
import ConfirmationDialog from '@common/components/ConfirmationDialog';

class InstituteDeactivationSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeactivating: false,
      deactivationError: null,
      deactivateAlertOpen: false,
      reactivateAlertOpen: false
    };
  }

  api = new ApiService();

  handleDeactivateDialog = (event) => {
    this.setState({ deactivateAlertOpen: true, reactivateAlertOpen: false });
  }

  handleReactivateDialog = (event) => {
    this.setState({ deactivateAlertOpen: false, reactivateAlertOpen: true });
  }

  handleActivationClose = () => {
    this.setState({ deactivateAlertOpen: false, reactivateAlertOpen: false });
  }

  handleDeactivateConfirm = (event) => {
    this.handleActivationClose();
    this.handleDeactivation(event, false);
  }

  handleReactivateConfirm = (event) => {
    this.handleActivationClose();
    this.handleDeactivation(event, true);
  }

  handleDeactivationMessage = (success, verb) => {
    this.setState({
      isDeactivating: false,
      deactivationError: success ? null : `Failed to ${verb} institute.`
    });
  };

  handleDeactivation = (event, newActive) => {
    const verb = newActive ? 'reactivate' : 'deactivate';

    this.setState({ isDeactivating: true, deactivationError: null });

    this.api.toggleActivation(`/institutes/${this.props.instituteDetails.id}`, newActive).then(response => {
      if (response.status >= 200 && response.status < 300) {
        this.handleDeactivationMessage(true, verb);
        this.props.onInstituteChange({ ...this.props.instituteDetails, active: newActive });
      }
      else {
        this.handleDeactivationMessage(false, verb);
      }

      return response;
    }).catch(() => {
      this.handleDeactivationMessage(false, verb);
    });
  };

  render() {
    const { classes, instituteDetails } = this.props;
    const { isDeactivating, deactivationError, deactivateAlertOpen, reactivateAlertOpen } = this.state;

    return (
      <>
        <Typography className={classes.sectionHeaders}>
          Deactivation
        </Typography>

        <Grid container alignItems="center" spacing={2}>
          <Grid size={12}>
            <Typography>
              Institute is currently {instituteDetails.active ? 'active' : 'deactivated'}.
            </Typography>
          </Grid>
          <Grid size={2}>
            <Button
              color="secondary"
              size="small"
              variant="contained"
              onClick={instituteDetails.active ? this.handleDeactivateDialog : this.handleReactivateDialog}
              disabled={isDeactivating}
            >
              <Typography variant="button">
                {instituteDetails.active ? 'Deactivate' : 'Reactivate'} Institute
              </Typography>
            </Button>
          </Grid>
          <Grid size={10}>
            {isDeactivating ?
              <CircularProgress size={24} /> : (
                <Typography color={"error"}>
                  {deactivationError}
                </Typography>
              )
            }
          </Grid>
        </Grid>
        <ConfirmationDialog
          message="This will prevent any educators, supervisors, institute admins, etc from logging in to the institute. Are you sure?"
          onOk={this.handleDeactivateConfirm}
          onCancel={this.handleActivationClose}
          open={deactivateAlertOpen}
          title={`Deactivate ${instituteDetails.name} institute?`}
        />
        <ConfirmationDialog
          message="This will allow all educators, supervisors, institute admins, etc to log in to the institute. Are you sure?"
          onOk={this.handleReactivateConfirm}
          onCancel={this.handleActivationClose}
          open={reactivateAlertOpen}
          title={`Reactivate ${instituteDetails.name} institute?`}
        />
      </>
    );
  }
}

export default withStyles(InstituteDeactivationSection, instituteDetailsStyles, {
  withTheme: true
});
